DigiTickets.SoldGiftVoucherRedeemableStatus = Object.freeze({
    EXPIRED: 'Expired',
    REDEEMABLE: 'Redeemable',
    REDEEMED: 'Redeemed',
    UNSUPPORTED: 'Unsupported'
});
